const createWidgetFactory = require('components-framework/widget/create_widget_factory');

module.exports = createWidgetFactory({
    name: 'membership_password_setup',
    viewClass: require('./view'),
    modelClass: require('./model'),
    isEnabled() {
        return Odigeo.Membership.isMembershipPasswordSetupPage;
    },
    methods: {
        renderWidget(info) {
            this.renderSetupPassword(info);
        },
        passwordWithError(error) {
            this.passwordError(error);
        },
        passwordChangedOk() {
            this.passwordOk();
        },
    },
});
